<template>
  <NotificationSettingsBase
    ref="baseRef"
    :connector="connector"
    display-mode="notifications"
    :onboardingMode="onboardingMode"
    :initialDefaultChannelId="initialDefaultChannelId"
    :hideSaveButton="hideSaveButton"
    @saved="$emit('saved', $event)"
    @save-state="$emit('save-state', $event)"
  />
</template>

<script>
import { defineComponent, ref } from 'vue'
import NotificationSettingsBase from '@/components/ClientNotifications/NotificationSettingsBase.vue'

export default defineComponent({
  name: 'NotificationSettings',
  components: { NotificationSettingsBase },
  emits: ['saved', 'save-state'],
  props: {
    connector: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    onboardingMode: {
      type: Boolean,
      default: false,
    },
    /** ID подключённого канала для подстановки в defaultChannel/yclientsChannel (YC онбординг: канал сначала) */
    initialDefaultChannelId: {
      type: [String, Number],
      default: null,
    },
    hideSaveButton: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const baseRef = ref(null)

    const requestSave = async () => {
      if (typeof baseRef.value?.save === 'function') {
        await baseRef.value.save()
      }
    }

    return {
      baseRef,
      requestSave,
    }
  },
})
</script>
